import { LinearProgress } from '@mui/material';
import { useEffect, useState, useContext } from 'react';
import LeadGenerationContext from '../../context/LeadGenerationContext';
import { productMapping } from '../../services/productMapping';
import {
  PRODUCT_PERSONAL,
  PRODUCT_PERSONALCD,
  PRODUCT_IRAEDUCATION,
  PRODUCT_IRAFACIL,
  ADDITIONAL_DBA,
  CONTACT_INFO,
  BUSINESS_INFO,
  PERSONAL_INFO,
  ADDRESS_INFO,
  COMPLIANCE_INFO,
  PRODUCT_INFO,
  BUSINESS_COMPLIANCE_INFO,
  BUSINESS_ADDITIONAL_INFO,
  BUSINESS_SURI,
  BUSINESS_ACCOUNT_INFO,
  BUSINESS_COMP,
  FUNDING_INFO,
  CONSENT_INFO,
  DGIADDITIONAL_INFO,
  FINANCE_INFO,
  EDELIVERY_INFO,
  PROGRESA_CONTIGO,
} from '../../constants';
import { dgiMapping } from '../../services/dgiMapping';
import { businessMapping } from '../../services/businessMapping';
import { productTypeMapping } from '../../services/productTypeMapping';
import { isCDIraproduct, isCDproduct, isIRAEducativaProduct } from '../commonCode';

function StepperConnector() {
  const [stepValue, setStepValue] = useState(0);
  const leadGenerationContext = useContext(LeadGenerationContext);

  const { currentPage } = leadGenerationContext;
  const fundingInfo = () => {
    if (dgiMapping(leadGenerationContext.productName)) {
      setStepValue(37);
    } else {
      const prodName = productMapping(leadGenerationContext.productName);
      if (
        prodName === PRODUCT_PERSONAL ||
        prodName === PRODUCT_IRAFACIL ||
        prodName === PRODUCT_PERSONALCD
      ) {
        setStepValue(36);
      } else {
        setStepValue(40);
      }
    }
  };
  const businessComp = () => {
    if (leadGenerationContext.businessContactInformation.businessType === ADDITIONAL_DBA) {
      setStepValue(36);
    } else {
      setStepValue(50);
    }
  };
  const stepValCond = () => {
    if (currentPage === BUSINESS_COMPLIANCE_INFO) {
      setStepValue(18);
    } else if (currentPage === BUSINESS_SURI) {
      setStepValue(33);
    } else if (currentPage === BUSINESS_ADDITIONAL_INFO) {
      setStepValue(33);
    } else if (currentPage === BUSINESS_ACCOUNT_INFO) {
      setStepValue(50);
    } else if (currentPage === 'invi-flow-info') {
      setStepValue(50);
    } else if (currentPage === CONSENT_INFO) {
      setStepValue(100);
    }
  };
  const pageCondition =
    currentPage === CONTACT_INFO ||
    currentPage === BUSINESS_INFO ||
    (currentPage === PERSONAL_INFO && leadGenerationContext.productName === PROGRESA_CONTIGO);
  const pageCondition2 = currentPage === PERSONAL_INFO;
  const certificateOfDeposit =
    isCDproduct(leadGenerationContext.productName) ||
    isCDIraproduct(leadGenerationContext.productName) ||
    isIRAEducativaProduct(leadGenerationContext.productName);
  //  && leadGenerationContext.productName === 'Consumer Credit';
  useEffect(() => {
    if (pageCondition) {
      setStepValue(0);
    } else if (currentPage === ADDRESS_INFO) {
      setStepValue(certificateOfDeposit ? 45 : 30);
    } else if (currentPage === COMPLIANCE_INFO) {
      setStepValue(50);
    } else if (currentPage === PRODUCT_INFO) {
      if (
        businessMapping(leadGenerationContext.productName) &&
        (productTypeMapping(leadGenerationContext.productType) === 'Checking Account' ||
          productTypeMapping(leadGenerationContext.productType) === 'Savings Account')
      ) {
        setStepValue(83);
      } else {
        setStepValue(certificateOfDeposit ? 55 : 63);
      }
    } else if (currentPage === BUSINESS_COMP) {
      businessComp();
      setStepValue(68);
    } else if (currentPage === 'document-checklist') {
      setStepValue(83);
    } else if (currentPage === FUNDING_INFO) {
      fundingInfo();
      setStepValue(certificateOfDeposit ? 69 : 80);
    } else if (currentPage === DGIADDITIONAL_INFO) {
      setStepValue(49);
    } else if (currentPage === FINANCE_INFO) {
      setStepValue(60);
    } else if (currentPage === EDELIVERY_INFO) {
      setStepValue(85);
    }
    stepValCond();
  }, [currentPage]);
  useEffect(() => {
    if (pageCondition) {
      setStepValue(0);
    } else if (currentPage === 'loan-participant-info') {
      setStepValue(17);
    } else if (currentPage === 'consumer-employment-income') {
      setStepValue(38);
    } else if (currentPage === 'loan-review') {
      setStepValue(50);
    } else if (currentPage === 'cd-review') {
      setStepValue(69);
    } else if (pageCondition2) {
      setStepValue(certificateOfDeposit ? 37 : 22);
    } else if (currentPage === PERSONAL_INFO) {
      setStepValue(17);
    }
  }, [currentPage]);
  return (
    <div className="stepper" style={{ left: '10px' }}>
      <LinearProgress variant="determinate" value={0} />
      <div className="active-progress-bar" style={{ width: `${stepValue}%` }} />
    </div>
  );
}

export default StepperConnector;
